import './LabelGroup-7d19205a.css';

var classes = {"Container":"prc-LabelGroup-Container-0bBKg","ItemWrapper":"prc-LabelGroup-ItemWrapper-ETvGq","ItemWrapper--hidden":"prc-LabelGroup-ItemWrapper--hidden-HzoA1","OverlayContainer":"prc-LabelGroup-OverlayContainer-pt4uv","OverlayInner":"prc-LabelGroup-OverlayInner-qvwGT","CloseButton":"prc-LabelGroup-CloseButton-GyJi3"};

export { classes as default };
